import { Component, OnInit } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FilterColumnService } from '@shared/services/filter-column/filter-column.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { cloneDeep } from "lodash";
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';
import { ExtensionDocumentPipe } from '../../../shared/filters/extension-document/extension-document.pipe';
import { ConvertDatePipe } from '../../../shared/filters/convert-date/convert-date.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { SpanTooltipComponent } from '../../../shared/components/span-tooltip/span-tooltip.component';
import { NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { AutoFocusModule } from 'primeng/autofocus';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FilterByListAndOrderComponent } from '@shared/components/filter-by-list-and-order/filter-by-list-and-order.component';
import { FilterBySearchAndOrderComponent } from "../../../shared/components/filter-by-search-and-order/filter-by-search-and-order.component";
import { FilterByOrderComponent } from "../../../shared/components/filter-by-order/filter-by-order.component";
import { PaginationControlComponent } from '@shared/components/pagination-control/pagination-control.component';
import { DropdownModule } from 'primeng/dropdown';
import { MenuModule } from 'primeng/menu';
import { DuplicateDocumentationCollegiateComponent } from "../duplicate-documentation-view/duplicate-documentation-collegiate/duplicate-documentation-collegiate.component";
import { DuplicateDocumentationDigitizationComponent } from "../duplicate-documentation-view/duplicate-documentation-digitization/duplicate-documentation-digitization.component";
import { DuplicateDocumentationPublicationComponent } from "../duplicate-documentation-view/duplicate-documentation-publication/duplicate-documentation-publication.component";
import { DuplicateDocumentationQueryComponent } from "../duplicate-documentation-view/duplicate-documentation-query/duplicate-documentation-query.component";
import { DuplicateDocumentationStepComponent } from "../duplicate-documentation-view/duplicate-documentation-step/duplicate-documentation-step.component";

@Component({
    selector: 'duplicate-documentation',
    templateUrl: './duplicate-documentation.component.html',
    standalone: true,
    imports: [AfTranslateDirective, AutoFocusModule, ProgressSpinnerModule, FilterByListAndOrderComponent, PaginationControlComponent, DropdownModule, MenuModule, FormsModule, NgClass, NgStyle, SpanTooltipComponent, AfOrderByPipe, AfTranslatePipe, ConvertDatePipe, ExtensionDocumentPipe, AfLimitToPipe, FilterBySearchAndOrderComponent, FilterByOrderComponent, DuplicateDocumentationCollegiateComponent, DuplicateDocumentationDigitizationComponent, DuplicateDocumentationPublicationComponent, DuplicateDocumentationQueryComponent, DuplicateDocumentationStepComponent]
})

export class DuplicateDocumentationComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  concept: any = this.dialogConfig.data.concept;
  listOriginDocuments: any = this.dialogConfig.data.listOriginDocuments;
  folderId: any = this.dialogConfig.data.folderId;
  duplicateDocumentation:any = {
    stepState: 'init',
    configPagination: {
      itemsPerPage: 10,
      pageLinkSize: 5,
      currentPage: 1,
      firstElement: 0
    },
    documentChecked: 0,
    searchText: '',
    copySearchText: '',
    search: '',
    titleValue: '',
    authorValue: '',
    searchProduct: '',
    filterOrder: 'CreationDate',
    order: true,
    searchingEvaluations: true,
    menuIcons: {
      icons: []
    },
    breadcrumbList: this.configureInitBreadcrumb(),
    documentsAdded: [],
    filterEvaluationTreeList: [],
    filterDocumentationList: [],
    conceptList: [],
    filters: ['extension'],
    extensionFilter: { name: this.translate.instant('common.type') },
    titleFilter: { name: this.translate.instant('common.title'), filterOrder: 'Name'},
    createdByFilter: { name: this.skin === 'icam-red'? this.translate.instant('common.creator') : this.translate.instant('common.author') },
    implantationFilter: { name: this.translate.instant('common.implantation'), filterOrder: 'EvaluationName' },
    organizationFilter: { name: this.translate.instant('common.organization'), filterOrder: 'ClientName' },
    creationDateFilter: { name: this.translate.instant('common.creation'), filterOrder: 'CreationdDate' },
    modificationDateFilter: { name: this.translate.instant('common.modification'), filterOrder: 'modificationDate' },
    createdFilter: { name: this.translate.instant('common.creation'), filterOrder: 'created' },
  }

  constructor(private commonUtilsService: CommonUtilsService,
    private globalCfg: GlobalCfgFactory,
    private apiService: ApiServiceService,
    private translate: AfTranslateFactory,
    private filterColumnService: FilterColumnService,
    private context: ContextFactory,
    private dateConverterService: DateConverterService,
    private loader: LoaderFactory,
    private dialogRef: DynamicDialogRef<DuplicateDocumentationComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.skin === 'icam-red'? this.getEvaluations() : this.getProducts();
  }

  configureInitBreadcrumb(){
    return this.skin === 'icam-red'?[]:[{nameBreadcrumb: this.translate.instant('common.implantations'), type: 'menu'}];
  }

  getEvaluations(){
    this.apiService.get('company', 'dashboard/evaluations')
      .then((data:any)=> {
        this.duplicateDocumentation.evaluationList = data;
        this.duplicateDocumentation.filterEvaluationList = this.duplicateDocumentation.evaluationList;
        this.duplicateDocumentation.searchingEvaluations = false;
      }, (errordata:any)=>{
        this.duplicateDocumentation.searchingEvaluations = false;
      });
  }

  getProducts(){
    this.apiService.get('products')
      .then((data:any)=>{
        this.duplicateDocumentation.productList = data.sort(this.orderList('name'));
        this.getEvaluations();
      }, (errorData:any)=>{});
  }

  changeView(){
    if(this.skin === 'icam-red'){
      this.selectEvaluation(this.duplicateDocumentation.evaluationList[0]);
    }else{
      this.duplicateDocumentation.filterOrder = 'name';
      this.duplicateDocumentation.order = false;
      this.duplicateDocumentation.implantationFilter.filterOrder = 'name';
      this.duplicateDocumentation.organizationFilter.filterOrder = 'clientName';
      this.duplicateDocumentation.creationDateFilter.filterOrder = 'creationDate';
      this.duplicateDocumentation.titleFilter.filterOrder = 'title';
      this.duplicateDocumentation.stepState = 'product';
    }
  }

  selectBreadcrumb(folder:any, disabled:boolean=false){
    if(!disabled){
      if(folder.type === 'menu'){
        if(this.duplicateDocumentation.stepState !== 'product'){
          this.duplicateDocumentation.breadcrumbList = this.configureInitBreadcrumb();
          this.duplicateDocumentation.filterOrder = 'name';
          this.duplicateDocumentation.order = false;
          this.duplicateDocumentation.stepState = 'product';
        }
      }else{
        let breadcrumbList:any = cloneDeep(this.duplicateDocumentation.breadcrumbList);
        this.duplicateDocumentation.breadcrumbList = [];
        for(let breadcrumbItem of breadcrumbList){
          folder.nameBreadcrumb = breadcrumbItem.name;
          this.duplicateDocumentation.breadcrumbList.push(breadcrumbItem);
          if(breadcrumbItem.id === folder.id){
            this.duplicateDocumentation.stepState = folder.stepState;
            break;
          }
        }
        this.selectFolder(folder, 'breadcrumb');
      }
    }
  }

  selectFolder(folder:any, type:any=''){
    let that: any = this.duplicateDocumentation;
    if((folder.folderId || folder.evaluationId) && !folder.conceptObjectId){
      if(folder.children.length || folder.concepts.length){
        if(type !== 'breadcrumb'){
          folder.stepState = that.stepState;
          folder.nameBreadcrumb = folder.name;
          folder.id = folder.folderId;
          that.breadcrumbList.push(folder);
        }
        that.filterEvaluationTreeList = folder.concepts?folder.children.concat(folder.concepts): folder.children;
      }else{
        that.filterEvaluationTreeList = [];
        folder.stepState = that.stepState;
        folder.nameBreadcrumb = folder.name;
        folder.id = folder.folderId;
        that.breadcrumbList.push(folder);
      }
      that.stepState = 'folder';
    }else if(folder.folderId && folder.conceptObjectId && folder.conceptObjectId !== 0 && folder.concepts && folder.concepts.length && !folder.concepts[0].multipleInstancesInAuto){
      that.searchingDocuments = true;
      that.filterOrder = 'created';
      that.order = true;
      that.stepState = 'instance';
      let conceptAutoinstanciable : any = folder.concepts[0];
      conceptAutoinstanciable.nameBreadcrumb = folder.name + ' (' +conceptAutoinstanciable.title+')';
      this.selectConcept(conceptAutoinstanciable, true);
    }else if(type !== 'breadcrumb'){
      folder.nameBreadcrumb = folder.title;
      that.stepState = 'concept';
      that.viewConceptTable = folder.namedKey;
      folder.stepState = that.stepState;
      that.searchingInstances = true;
      this.selectConcept(folder);
    }else if(type === 'breadcrumb' && folder.conceptObjectId){
      that.order = true;
      that.documentChecked = 0;
      // that.filterDocumentationList = [];
      that.documentList = folder.children;
      that.filterDocumentationList = that.documentList;
      that.extensionList = this.filterColumnService.extractList('extension',  that.filterDocumentationList);
      that.selectAllDocument = true;
      this.selectAllDocumentCheckDuplicate();
    }else if(folder.conceptId){
      that.filterOrder = 'creationDate';
      that.order = true;
    }
    this.changeCurrentPage({currentPage: 1, firstElement: 0});
    if(that.stepState !== 'product'){
      this.calculeShowBreadcrumb();
    }
  }

  selectConcept(concept:any, autoinstanciable:boolean = false){
    let that: any = this.duplicateDocumentation;
    let path = this.skin === 'icam-red' ? 'icam/conceptobjects/byconceptid' : 'conceptobjects/byconceptid';
    this.apiService.get(path, concept.conceptId)
      .then((data:any)=>{
        that.conceptList = [];
        data.forEach((item:any) => {
          if(this.skin === 'icam-red'){
            item.namedKey = concept.namedKey;
          }
          if(item.conceptObjectId !== this.concept.conceptObjectId || autoinstanciable){
            that.conceptList.push(item);
          }
        });

        concept.children = that.conceptList;
        concept.id = concept.conceptId;
        if(autoinstanciable){
          concept.children[0].title = concept.nameBreadcrumb;
          this.selectInstance(concept.children[0]);
        }else{
          that.filterConceptList = that.conceptList;
          that.searchingInstances = false;
          that.breadcrumbList.push(concept);
          if(this.skin !== 'icam-red'){
            that.filterOrder = 'creationDate';
          }
        }
      }, (errorData:any)=>{
        that.searchingInstances = false;
      });
  }

  getFilters(list:any) {
    this.duplicateDocumentation.filters.forEach((filter:any) => {
      this.duplicateDocumentation[filter+'List'] = this.filterColumnService.extractList(filter, list);
      this.duplicateDocumentation[filter+'ListFilter'] = [];
    });
  }

  resetSearch(){
    this.duplicateDocumentation.searchText = '';
    this.duplicateDocumentation.searchTextError = false;
  }

  goToPressEnter(event:any){
    if(event.which === 13){
      this.goToSearch();
    }
  }

  goToSearch(){
    if(this.duplicateDocumentation.searchText.length >= 3 && this.duplicateDocumentation.searchText !== this.duplicateDocumentation.copySearchText){
      this.goToSearchFunction();
    }else if(this.duplicateDocumentation.searchText.length < 3){
      this.duplicateDocumentation.searchTextError = true;
    }
  }

  goToSearchFunction(){
    let that: any = this.duplicateDocumentation;
    this.duplicateDocumentation.searchTextError = false;
    that.searchingDocuments = true;
    that.implantationFilter.filterOrder = 'EvaluationName';
    that.organizationFilter.filterOrder = 'ClientName';
    that.creationDateFilter.filterOrder = 'CreationDate';
    that.titleFilter.filterOrder = 'Name';
    this.changeCurrentPage({currentPage: 1, firstElement: 0});
    that.stepState = 'search';
    that.copySearchText = that.searchText;
    that.filterOrder = 'CreationDate';
    this.duplicateDocumentation.documentChecked = 0;
    this.apiService.get('search/type/Documents?text=' + that.searchText + '&onlyResults=true', undefined)
      .then((data:any)=>{
        that.documentList = [];
        data.Documents.Results.forEach((document:any) => {
          if(document.ConceptObjectId !== this.concept.conceptObjectId && (document.documentObjectId || document.DocumentObjectId)){
            document.documentObjectId = document.documentObjectId ?? document.DocumentObjectId;
            document.extension = document.Name.slice(document.Name.lastIndexOf(".")+1, document.Name.length);
            that.documentList.push(document);
          }
        });
        that.filterDocumentationList = that.documentList;
        that.searchingDocuments = false;
        that.filters = ['extension'];
        this.getFilters(that.filterDocumentationList);
      }, (errorData:any)=>{
        that.searchingDocuments = false;
      })
  }

  selectTypeOperation(item:any, type:any){
    let listFilter : any = this.duplicateDocumentation[type+'ListFilter'];
    this.duplicateDocumentation[type+'ListFilter'] = this.filterColumnService.configureFilterList(listFilter, item);
    this.filterDocumentation();
  }

  filterDocumentation(type:any=''){
    let filterList:any = [];
    let list = this.duplicateDocumentation.documentList;
    let searchFilter:any = this.duplicateDocumentation.titleValue;
    let searchWord:string = 'title';
    if(this.duplicateDocumentation.stepState === 'product'){
      list = this.duplicateDocumentation.evaluationList;
    }else if(this.duplicateDocumentation.stepState === 'concept'){
      list = this.duplicateDocumentation.conceptList;
    }
    if (type) {
      searchFilter = this.duplicateDocumentation[type + 'Value'];
      searchWord = type;
    }
    filterList = this.filterColumnService.filterByWord(searchFilter,  list, searchWord);
    this.duplicateDocumentation.filters.forEach((filter:any) => {
      let filteredList:any = this.duplicateDocumentation[filter+'ListFilter'];
      filterList = this.filterColumnService.filterBycolumn(filterList, filteredList, filter);
    });

    if(this.duplicateDocumentation.stepState === 'product'){
      this.duplicateDocumentation.filterEvaluationList = filterList;
    }else if(this.duplicateDocumentation.stepState === 'concept'){
      this.duplicateDocumentation.filterConceptList = filterList;
    }else{
      this.duplicateDocumentation.filterDocumentationList = filterList;
    }
    // this.duplicateDocumentation.totalItemsPagination = filterList.length;
  }

  selectAllDocumentCheckDuplicate(){
    this.duplicateDocumentation.selectAllDocument = !this.duplicateDocumentation.selectAllDocument;
    this.duplicateDocumentation.filterDocumentationList.forEach((document:any) => {
      if(!document.folderId && document.selectedDocument !== this.duplicateDocumentation.selectAllDocument){
        document.selectedDocument = this.duplicateDocumentation.selectAllDocument;
        if(document.selectedDocument){
          this.duplicateDocumentation.documentChecked++;
        }else{
          if(this.duplicateDocumentation.documentChecked > 0){
            this.duplicateDocumentation.documentChecked--;
          }
        }
      }
    });
  }

  selectMultipleDocument(document:any){
    if(document.folderId){
      this.duplicateDocumentation.searchingDocuments = true;
      this.changeFolder(document);
    }else{
      document.selectedDocument = !document.selectedDocument;
      this.duplicateDocumentation.selectedFromOption = false;
      if(document.selectedDocument){
        this.duplicateDocumentation.documentChecked++;
      }else{
        this.duplicateDocumentation.selectAllDocument = false;
        this.duplicateDocumentation.documentChecked--;
      }
    }
  }

  changeFolder(folder:any){
    let that: any = this.duplicateDocumentation;
    that.documentList = [];
    that.documentChecked = 0;
    folder.id = folder.folderId;
    folder.nameBreadcrumb = folder.name;
    folder.conceptObjectId = that.conceptObjectIdFromInstance;
    this.configureListDocuments(folder, folder);
  }

  backInit(){
    let that: any = this.duplicateDocumentation
    that.searchText = '';
    that.copySearchText = '';
    that.extensionFilter.hasFilter = false;
    this.changeCurrentPage({currentPage: 1, firstElement: 0});
    that.stepState = 'init';
    that.filterEvaluationList = that.evaluationList;
    that.breadcrumbList = this.configureInitBreadcrumb();
    that.selectAllDocument = true;
    delete this.duplicateDocumentation.selectedProduct;
    this.selectAllDocumentCheckDuplicate();
  }

  orderDate(type:any){
    if(this.duplicateDocumentation.filterOrder === type){
      this.duplicateDocumentation.order = !this.duplicateDocumentation.order;
    }else{
      this.duplicateDocumentation.filterOrder = type;
      this.duplicateDocumentation.order = true;
    }
  }

  selectProduct(){
    if(this.duplicateDocumentation.selectedProduct){
      this.duplicateDocumentation.filterEvaluationList = this.commonUtilsService.filterEvaluationByProduct(this.duplicateDocumentation.evaluationList, this.duplicateDocumentation.selectedProduct);
    }else{
      this.duplicateDocumentation.filterEvaluationList = this.duplicateDocumentation.evaluationList;
    }
    this.duplicateDocumentation.filterProduct = '';
  }

  selectInstance(instance:any){
    let that: any = this.duplicateDocumentation;
    that.stepState = 'instance';
    that.searchingDocuments = true;
    that.filterOrder = 'created';
    that.order = true;
    that.filterDocumentationList = [];
    this.apiService.get('documentobjects/'+instance.conceptObjectId)
      .then((data:any)=>{
        this.addExtensionFolder(data.subFolders);
        instance.nameBreadcrumb = instance.title;
        instance.id = instance.conceptObjectId;
        that.conceptObjectIdFromInstance = instance.conceptObjectId;
        this.configureListDocuments(instance, data);
      }, (errorData:any)=>{
        that.searchingDocuments = false;
      });
  }

  configureListDocuments(folder: any, listDocuments: any){
    let that: any = this.duplicateDocumentation;
    this.changeCurrentPage({currentPage: 1, firstElement: 0});
    that.documentList = listDocuments.documents;
    that.documentList = [...that.documentList, ...listDocuments.subFolders];
    that.filterDocumentationList = that.documentList;
    folder.children = that.filterDocumentationList;
    folder.stepState = that.stepState;
    that.breadcrumbList.push(folder);
    that.filters = ['extension'];
    this.getFilters(that.filterDocumentationList);
    this.calculeShowBreadcrumb();
    that.searchingDocuments = false;
  }

  addExtensionFolder(list:any){
    list.forEach((item:any) => {
      if(item.folderId){
        item.extension = this.translate.instant('duplicate-documentation.folder');
      }
      if(item.subFolders && item.subFolders.length){
        this.addExtensionFolder(item.subFolders);
      }
    });
  }

  selectEvaluation(evaluation:any){
    let that: any = this.duplicateDocumentation;
    evaluation.stepState = that.stepState;
    this.changeCurrentPage({currentPage: 1, firstElement: 0});
    that.stepState = 'folder';
    that.searchingTreeEvaluation = true;
    that.treeList = [];
    this.apiService.getWithTranslate('tree/translated', evaluation.evaluationId)
      .then((data:any)=> {
        if(data.length){
          this.getEvaluationMenuIcons(evaluation, data);
        }
        that.treeList = data;
        that.filterEvaluationTreeList = that.treeList;
        evaluation.children = that.treeList;
        evaluation.nameBreadcrumb = that.skin === 'icam-red'? evaluation.productName : evaluation.name;
        evaluation.id = evaluation.evaluationId;
        that.breadcrumbList.push(evaluation);
        this.calculeShowBreadcrumb();
      }, (errorData:any)=>{
        that.searchingTreeEvaluation = false;
      })
  }

  getEvaluationMenuIcons(evaluation:any, list:any){
    this.apiService.getMenuIcons()
      .then((data:any)=>{
        for(let item of data){
          if(item.productId === evaluation.productId){
            this.duplicateDocumentation.menuIcons = item;
            this.duplicateDocumentation.product = item.productId;
            break;
          }
        }
        this.configureIcons(list);
      }, ()=>{})
  }

  configureIcons(list:any){
    list.forEach((children:any) => {
      children.icon = this.getIcon(children);
    });
  }

  getIcon(children:any){
    this.duplicateDocumentation.searchingTreeEvaluation = false;
    for(let icon of this.duplicateDocumentation.menuIcons.icons){
      if(icon['iD_Version0'+this.context.environment] === children['iD_Version0']){
        return  icon.icon;
      }
    }
    return children.isFront? "lf-icon-folder-user" : "lf-icon-folder";
  }

  importDocuments(){
    let that: any = this.duplicateDocumentation;
    let count : any= 0;
    let countMilisecond : any = 100;
    that.errors = [];
    that.callsFinish = 0;
    that.filterDocumentationList.sort(this.orderList('CreationDate'));
    for(let document of that.filterDocumentationList){
      if(document.selectedDocument){
        count++;
        if(document.DocumentObjectId){
          document.name = document.Name;
          document.documentObjectId = document.DocumentObjectId;
        }
        if(this.checkedName(this.listOriginDocuments, document, 'documentObjectId')){
          countMilisecond+=5;
          this.copyDocument(document, countMilisecond);
        }else{
          document.text = document.name;
          that.errors.push(document);
          that.callsFinish++;
        }
        if(count === that.documentChecked){
          if(count === that.errors.length){
            let message: string = count === 1? 'error-in-document': 'error-all-documents';
            this.handleAccept(message);
          }
          break;
        }
      }
    }
  }

  checkedName(list:any, item:any, type:any){
    for(let listItem of list){
      if(listItem[type] && listItem.name === item.name){
        return false;
      }
    }
    return true;
  }

  copyDocument(document:any, countMilisecond:any){
    this.loader.openLoader('copy-documents');
    let creationDate: any;
    let url:string = 'documentobjects/copy/'+ document.documentObjectId + '/' + this.concept.conceptObjectId;
    if(this.folderId){
      url = url + '/' + this.folderId;
    }else{
      creationDate = this.dateConverterService.toIso(new Date(), countMilisecond);
      url = url + '?creationDate=' + creationDate;
    }
    this.apiService.add(url)
      .then((data:any)=>{
        this.duplicateDocumentation.callsFinish++;
        data.sourceName = this.translate.instant('common.documentation');
        data.creationDate = creationDate;
        this.duplicateDocumentation.documentsAdded.push(data);
        if(this.duplicateDocumentation.callsFinish === this.duplicateDocumentation.documentChecked){
          let message : string = 'ok';
          if(this.duplicateDocumentation.errors?.length){
            message = 'ok-with-errors';
          }
          this.handleAccept(message);
        }
      }, (errorData:any)=>{
        this.loader.closeError();
      })
  }

  launchAction(e: any){
    switch(e.action){
      case 'selectInstance':
        this.selectInstance(e.instance);
        break;
      case 'getFilters':
        this.getFilters(this.duplicateDocumentation.conceptList);
        break;
      case 'filterOrder':
        this.filterOrder(e.event, e.type);
        break;
      case 'changeCurrentPage':
        this.changeCurrentPage(e.event);
        break;
      default:
        break;
    }
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

  handleAccept(message:any) {
    this.dialogRef.close({
      result: message,
      documentErrors: this.duplicateDocumentation.errors,
      documentsAdded: this.duplicateDocumentation.documentsAdded.sort(this.orderList('CreationDate'))
    });
  }

  orderListReverse(type: any){
    return function(a: any, b:any) {
      if (a[type] < b[type]) {
        return 1;
      }
      return a[type] > b[type] ? -1 : 0;
    }
  }

  orderList(type: any){
    return function(a: any, b:any) {
      if (a[type] > b[type]) {
        return 1;
      }
      return a[type] < b[type] ? -1 : 0;
    }
  }

  filterOrder(e: any, type:any=''){
    switch(e.action){
      case 'filter':
        this.selectTypeOperation(e.newValue, type);
        break;
      case 'search':
        this.duplicateDocumentation[type+'Value'] = e.newValue;
        this.filterDocumentation(type);
        break;
      case 'order':
        this.orderDate(type);
        break;
    }
  }

  changeCurrentPage(e: any){
    this.duplicateDocumentation.configPagination.currentPage = e.currentPage;
    this.duplicateDocumentation.configPagination.firstElement = e.firstElement;
  }

  resetSearchDropdown(options: any) {
    options.reset();
    this.duplicateDocumentation.filterProduct = '';
  }

  calculeShowBreadcrumb() {
    this.duplicateDocumentation.showMoreBreadcrumbs = false;
    let breadcrumbBlock: any = document.getElementById('duplicateDocumentationListBreadcrumbs');
    let limitBreadcrumb: any;
    if(breadcrumbBlock.offsetWidth < (this.duplicateDocumentation.breadcrumbList.length*40)-4){
      this.duplicateDocumentation.showMoreBreadcrumbs = true;
      limitBreadcrumb = this.duplicateDocumentation.breadcrumbList.length - Math.floor(breadcrumbBlock.offsetWidth / 40);
    }
    for(let i = 0; i < this.duplicateDocumentation.breadcrumbList.length; i++){
      this.duplicateDocumentation.breadcrumbList[i].hidden = false;
      if(this.duplicateDocumentation.showMoreBreadcrumbs && i <= limitBreadcrumb){
        this.duplicateDocumentation.breadcrumbList[i].hidden = true;
      }
    }
  }

}
